(function () {
  if (window.theme?.pageType && window.theme.pageType !== 'index') {
    return;
  }

  const instances = new WeakMap();

  const initHero = (hero) => {
    if (!hero || instances.has(hero)) {
      return;
    }

    const slides = Array.from(hero.querySelectorAll('[data-cc-home-hero-slide]'));
    const dots = Array.from(hero.querySelectorAll('[data-cc-home-hero-dot]'));
    const toggle = hero.querySelector('[data-cc-home-hero-toggle]');

    if (slides.length <= 1) {
      return;
    }

    const speed = Number(hero.dataset.autoplaySpeed) || 5000;
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const canAutoplay = hero.dataset.autoplay === 'true' && !prefersReducedMotion;
    const labels = {
      play: hero.dataset.playLabel || 'Play',
      pause: hero.dataset.pauseLabel || 'Pause',
    };
    let activeIndex = 0;
    let isPaused = !canAutoplay;
    let timer = null;

    const showSlide = (nextIndex) => {
      if (!slides[nextIndex]) {
        return;
      }

      slides[activeIndex].classList.remove('is-active');
      dots[activeIndex]?.classList.remove('is-active');
      dots[activeIndex]?.removeAttribute('aria-current');
      activeIndex = nextIndex;
      slides[activeIndex].classList.add('is-active');
      dots[activeIndex]?.classList.add('is-active');
      dots[activeIndex]?.setAttribute('aria-current', 'true');
    };

    const scheduleNext = (delay) => {
      if (isPaused) {
        return;
      }

      window.clearTimeout(timer);
      timer = window.setTimeout(() => {
        showSlide((activeIndex + 1) % slides.length);
        scheduleNext(speed);
      }, delay);
    };

    const start = (delay = speed) => {
      // Keep the first eager hero image stable long enough to own mobile LCP before autoplay begins.
      if (!canAutoplay || isPaused) {
        return;
      }

      scheduleNext(delay);
    };

    const onDotClick = (event) => {
      window.clearTimeout(timer);
      showSlide(Number(event.currentTarget.dataset.ccHomeHeroDot));

      if (canAutoplay && !isPaused) {
        start();
      }
    };

    const onToggleClick = () => {
      if (!canAutoplay) {
        return;
      }

      isPaused = !isPaused;
      toggle.textContent = isPaused ? labels.play : labels.pause;
      toggle.setAttribute('aria-pressed', String(isPaused));

      if (isPaused) {
        window.clearTimeout(timer);
      } else {
        start();
      }
    };

    dots.forEach((dot) => dot.addEventListener('click', onDotClick));
    if (canAutoplay) {
      toggle?.addEventListener('click', onToggleClick);
    }
    start(speed);

    instances.set(hero, {
      destroy() {
        window.clearTimeout(timer);
        dots.forEach((dot) => dot.removeEventListener('click', onDotClick));
        toggle?.removeEventListener('click', onToggleClick);
      },
    });
  };

  const destroyHero = (hero) => {
    const instance = instances.get(hero);

    if (!instance) {
      return;
    }

    instance.destroy();
    instances.delete(hero);
  };

  const initAll = (root = document) => {
    root.querySelectorAll('[data-cc-home-hero]').forEach(initHero);
  };

  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-cc-home-hero]').forEach(destroyHero);
  });
})();
